.b{justify-content:center;}